export const ECOSYSTEM_ITEMS = [
  { name: "Gig Projects", desc: "Work without the traditional baggage.", size: "s-5 t-2", variant: "dark" },
  { name: "Contests", desc: "Ideas compete. Talent rises.", size: "s-4", variant: "" },
  { name: "Pitches", desc: "Build teams around opportunities.", size: "s-3", variant: "orange" },
  { name: "Events", desc: "Meet the tribe in real life.", size: "s-4", variant: "lime" },
  { name: "Marketplace", desc: "Services, tools, and collaboration.", size: "s-3", variant: "" },
  { name: "Academy", desc: "Learn what the future actually needs.", size: "s-5", variant: "sand" },
  { name: "AI Tools", desc: "Amplify human creativity.", size: "s-4 t-2", variant: "dark" },
  { name: "AI Talent Factory", desc: "Train the next generation of AI-native talent.", size: "s-4", variant: "" },
  { name: "Co-Work", desc: "Shared spaces for builders.", size: "s-4", variant: "" },
  { name: "Co-Create", desc: "Collaborate across disciplines.", size: "s-3", variant: "lime" },
  { name: "Co-Live", desc: "Live differently. Build differently.", size: "s-3", variant: "" },
  { name: "Studio", desc: "Where ideas become brands & products.", size: "s-3", variant: "orange" },
  { name: "Campus", desc: "Future-ready learning environments.", size: "s-3", variant: "" },
  { name: "Fund", desc: "Backing unconventional builders.", size: "s-4", variant: "sand" },
];
